export default __webpack_public_path__ + "static/media/homepage2.f146b1ba.png";